module.exports = __webpack_public_path__ + "img/prize-01.f48f7b7f.png";